import axios from 'axios'

const Axois = axios.create({
  baseURL: 'https://caspian-finance-server-58e8b535cab0.herokuapp.com/accounting',
  // baseURL: 'http://localhost:7900/accounting',
  // baseURL: 'http://192.168.0.179:7900/accounting',
  withCredentials: true
})

export default Axois
